// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--NUTBv"};